








































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';

@Component({
  components: {
    SwButton,
    SwModal,
    SwModalFooter,
    SwModalBody,
  },
})

export default class RevokeOrDeclineAff extends SwExtendedVue {

  @Prop({ required: true })
  displayData: any;

  @Prop({ required: true })
  showRevokeOrDecline: any;

  get heading() {
    return this.$t('affiliation.revokeAff');
  }

  closeRevoke() {
    this.$emit('close-modal', false);
  }

  revoke() {
    this.$emit('close-modal', true);
  }

  created() {
    console.warn('details', this.displayData);
  }
}
